'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.isDev = isDev;
exports.isProd = isProd;
exports.isAdmin = isAdmin;
exports.isIOS = isIOS;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isMystique = isMystique;
exports.isTest = isTest;
exports.log = log;
exports.warn = warn;

var _isDev = null;
var _isAdmin = null;
var _isIOS = null;
var _isAndroid = null;
var _isMystique = null;
var _isBrowser = null;
var _isTest = null;

function isDev() {
  if (_isDev === null) {
    // TODO(lmr): handle server side
    var className = global.document && global.document.body && global.document.body.className;
    _isDev = /\bdevelopment\b/.test(String(className));
  }
  return _isDev;
}

function isProd() {
  return !isDev();
}

function isAdmin() {
  return false;
}

function isIOS() {
  return false;
}

function isAndroid() {
  return false;
}

function isBrowser() {
  if (_isBrowser === null) {
    _isBrowser = typeof document !== 'undefined';
  }
  return _isBrowser;
}

function isMystique() {
  return !isBrowser();
}

function isTest() {
  return false;
}

function log() {
  if (typeof console === 'undefined' || !console.log) return;
  Function.apply.call(console.log, console, arguments);
}

function warn() {
  if (typeof console === 'undefined' || !console.warn) return;
  Function.apply.call(console.warn, console, arguments);
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-env/build/env.js
// module id = 451
// module chunks = 168707334958949